import { buildProps } from '@lit-element/utils'
import type { ExtractPropTypes } from 'vue'
import type overflow from './overflow.vue'

export const overflowProps = buildProps({
  items: {
    type: Array as () => string[],
    default: [],
  },
  // 设置显示元素的最大数，为 0 时会根据宽度动态计算以确保在一行内显示
  maxCount: {
    type: Number,
    default: null,
  },
} as const)
export type OverflowProps = ExtractPropTypes<typeof overflowProps>
export type OverflowInstance = InstanceType<typeof overflow>
